/**
 * Central route constants for the Meetings module.
 *
 * These are used for navigation + building link URLs in list/join/form pages.
 * Keeping them here avoids scattering hard-coded paths throughout components.
 */

/** Admin routes */
export const ADMIN_MEETINGS_LIST_PATH = '/admin/meetings/list';
export const ADMIN_MEETINGS_QUICK_CALL_LIST_PATH = '/admin/meetings/list';
export const ADMIN_MEETINGS_MEET_LIST_PATH = '/admin/meetings/list?tab=meet';
export const ADMIN_MEETINGS_QUICK_CALL_BASE_PATH = '/admin/meetings/quick-call';
export const ADMIN_MEETINGS_MEET_BASE_PATH = '/admin/meetings/meet';
export const ADMIN_MEETINGS_QUICK_CALL_NEW_PATH =
  '/admin/meetings/quick-call/new';
export const ADMIN_MEETINGS_MEET_NEW_PATH = '/admin/meetings/meet/new';

/** Member (community) routes */
export const MEMBER_MEETINGS_LIST_PATH = '/community/meetings/list';
export const MEMBER_MEETINGS_QUICK_CALL_LIST_PATH = '/community/meetings/list';
export const MEMBER_MEETINGS_MEET_LIST_PATH = '/community/meetings/list?tab=meet';
export const MEMBER_MEETINGS_QUICK_CALL_BASE_PATH = '/community/meetings/quick-call';
export const MEMBER_MEETINGS_MEET_BASE_PATH = '/community/meetings/meet';
export const MEMBER_MEETINGS_QUICK_CALL_NEW_PATH =
  '/community/meetings/quick-call/new';
export const MEMBER_MEETINGS_MEET_NEW_PATH = '/community/meetings/meet/new';

/** Shared copy */
export const MEETINGS_PAGE_TITLE = 'Meetings';
export const MEETINGS_PAGE_SUBTITLE =
  'Create, share, and manage instant video calls.';
